module.exports = __webpack_public_path__ + "static/img/11.b6346ae.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/11.jpeg
// module id = wjrk
// module chunks = 0